import { Form, Formik, Field } from "formik"
import * as Yup from "yup";
import { images } from "../../assets/images";
import { useState } from "react";
import { Oval } from "react-loader-spinner";
import { forgotPassword } from "../../services";

export const ForgotPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const initialValues = {
        email: '',
    }
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = values => {
        setIsLoading(true);
        forgotPassword(values).then(response =>{
            const data = response.data;
            setIsLoading(false);
            setMessage(data.message)
            setSuccess(true);
        }).catch(err => {
            const data = err.response.data;
            setIsLoading(false);
            setMessage(data.message)
            console.error(err);
        })
    }

    const EmailSchema = Yup.object().shape({
        email: Yup.string().email().required("Email is required.")
    })

    return (
        <main className="flex flex-col items-center gap-[15rem] has-black-bg has-full-height">
            <header className="w-[90%] mx-auto pt-12">
                <a href="https://skinsagency.com">
                    <img src={images.logo} alt="logo" />
                </a>
            </header>
            <article className="flex flex-col items-start justify-start">
                <h1 className="text-6xl text-light-grey font-light">Forgot Password?</h1>
                {success ? (
                    <h2 className="text-3xl pt-4 pb-4">{message}</h2>
                ) : (
                <Formik
                    initialValues={initialValues}
                    onSubmit={values => handleSubmit(values)}
                    validationSchema={EmailSchema}
                >
                    {({ errors, touched }) => (
                        <Form className="w-full">
                            <fieldset className="flex flex-col gap-3 mt-5 mb-5">
                                <Field
                                    name="email"
                                    type="text"
                                    className="has-border-bottom"
                                    placeholder="Email"
                                    autoComplete="off" />
                                {errors.email && touched.email ? (
                                    <p className="required has-red-text text-xs mb-2">{errors.email}</p>
                                ) : null}
                                {message && message !== '' && (
                                    <p className="required has-red-text text-xs">{message}</p>
                                ) }
                            </fieldset>
                            <button className="btn btn-login w-full" type="submit">
                                {isLoading ? (
                                    <Oval
                                        height={30}
                                        width={50}
                                        color="black"
                                        secondaryColor="black"
                                    />
                                ) : (
                                    <span className="text-black">Send Email</span>
                                )}
                            </button>
                        </Form>
                    )}
                </Formik>
                )}
                <a href="/login" className="has-yellow-text mt-4">Back to Login</a>
            </article>
        </main>
    )
}